<template>
    <div class="contact-promotion__row">
        <div class="contact-promotion__cell">
            <label class="contact-promotion__name" v-tooltip:overflow="promotionCoupon.promotion.name">
                {{ promotionCoupon.promotion.name }}
            </label>
        </div>
        <div class="contact-promotion__cell">
            <label class="contact-promotion__code" v-tooltip:overflow="promotionCoupon.code">
                {{ promotionCoupon.code }}
            </label>
        </div>
        <div class="contact-promotion__cell">
            <label class="contact-promotion__date" v-tooltip:overflow="promotionCouponAllocatedAt">
                {{ promotionCouponAllocatedAt }}
            </label>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { VxTooltip as VTooltip } from '@voxie/frontend-components-v3';
import { shortDateTimeTzSpread } from '../../../utils/date';

const props = defineProps({
    promotionCoupon: {
        type: Object,
        required: true,
    },
});

const promotionCouponAllocatedAt = computed(() => shortDateTimeTzSpread(props.promotionCoupon.allocated_at));
</script>

<style lang="scss">
.contact-promotion__row {
    display: grid;
    grid-template-columns: 50% 25% 25%;
    font-family: var(--font-open-sans);

    &:nth-of-type(even) {
        background-color: var(--color-background);
    }
}

.contact-promotion__cell {
    padding: 16px;

    label {
        font-size: 0.875rem; // 14px
        margin: 0;
        color: var(--color-grey);
    }
}

.contact-promotion__code,
.contact-promotion__date {
    font-weight: var(--weight-regular);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 100%;
}

.contact-promotion__name {
    font-weight: var(--weight-semibold);
    overflow: hidden;
    text-overflow: ellipsis;

    display: -webkit-box !important;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal;

    div[id^='vx-tooltip'] {
        max-width: 400px;
    }
}
</style>
